// TEMP performance A/B diagnostic. Lets us measure, on the same deployed build, which render-cost lever
// stops the continuous style→layout→paint→composite storm that pins WebContent CPU on the kiosk (the
// Chrome trace showed it is the render pipeline, not JS). Toggle via `?perf=lever1|lever2|both|off`,
// persisted to localStorage so it survives kiosk reloads. Default (no flag) = current behaviour, so this
// is inert in production. REMOVE this file and its call sites once the minimum-visual-cost fix is chosen.
//
//   ?perf=lever1  → disable the order-flow loader animations (Skeleton pulse, CircularProgress, modal ring)
//   ?perf=lever2  → disable the live backdrop-filter blur (measures the blur's per-frame re-render cost)
//   ?perf=both    → both
//   ?perf=off     → clear the flag (control)

type PerfLever = "lever1" | "lever2" | "both";

const readPerfLever = (): PerfLever | null => {
	try {
		const param = new URLSearchParams(window.location.search).get("perf");
		if (param === "lever1" || param === "lever2" || param === "both") {
			localStorage.setItem("perfExperiment", param);
		} else if (param === "off" || param === "false") {
			localStorage.removeItem("perfExperiment");
		}
		const stored = localStorage.getItem("perfExperiment");
		return stored === "lever1" || stored === "lever2" || stored === "both" ? stored : null;
	} catch {
		return null;
	}
};

/** Lever 1: stop the continuous loader animations (Skeleton pulse, CircularProgress, modal timeout ring). */
export const shouldDisableAnimations = (): boolean => {
	const lever = readPerfLever();
	return lever === "lever1" || lever === "both";
};

/** Lever 2: drop the live `backdrop-filter: blur` so it stops re-rendering its backdrop every frame. */
export const shouldDisableBlur = (): boolean => {
	const lever = readPerfLever();
	return lever === "lever2" || lever === "both";
};
